import { Helmet } from "react-helmet-async";

export default function BusinessLoanPage() {
    return (
      <div className="w-full min-h-screen bg-gray-100 p-4">
         <Helmet>
                <title>Kota HOLDINGS</title>
                <meta name="description" content="A Vision of My 30-Year World" />
              </Helmet>
        <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-[#FF6F00] text-white p-6">
            <h2 className="text-2xl font-bold">We provide the best value Business Loan</h2>
            <p className="mt-2">Get instant approval for Business loans with minimal documentation and quick disbursal.</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
              <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
              <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
            </div>
            <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
            <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Apply Now</button>
          </div>
        </div>
        <div className=" mx-auto overflow-hidden mt-6">
          <div className="p-6">
            <h3 className="text-xl font-bold">Common Documents Required</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Proof of address & photo identity proof of the promoters</li>
              <li>Business proof, income proof.</li>
              <li>Partnership deed for partnership firm</li>
              <li>Articles of association, memorandum of association</li>
              <li>Stable employment and a good credit history.</li>
              <li>Board resolution, PAN card, etc.</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Features and Benefits of our Business Loans
            </h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Term Loans</li>
              <li>Working Capital Loans</li>
              <li>Business Expansion Loans.</li>
              <li>Equipment Financing Loans</li>
              <li>Invoice Financing & Bill Discounting</li>
              <li>GST/VAT Registration for self-employed individuals.</li>
              <li>Business Proof: MOA, AOA, partnership deed, etc.</li>
              <li>Machinery Loans</li>
            </ul>
                </div>
                <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Eligibility Criteria & Eligible Entities
            </h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Business Type: Sole Proprietorships, Partnerships, LLCs, Corporations</li>
              <li>Credit Score: Minimum 700</li>
              <li>Business Age: Minimum 1 year</li>
              <li>Annual Revenue: Defined by the bank/NBFC</li>
              <li>Nationality: Indian citizens</li>
            </ul>
                </div>
                <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Documentation for Business Loans
            </h3>
            <ul className="list-disc ml-6 mt-2">
              <li>ITR for the past 2-3 years</li>
              <li>Current Bank Account Statement for the last 12 months</li>
              <li>PAN Card, Address Proof</li>
              <li>Company's business profile</li>
                        <li>GST registration certificate</li>
                        <li>Rent agreement (if applicable)</li>

            </ul>
                </div>
                
        </div>
      </div>
    );
  }
  